var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.onLandingPage)?_c('app-header'):_vm._e(),_c('router-view',{class:_vm.landingPageStyle}),_c('app-footer',{attrs:{"showAppTools":_vm.showAppTools}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }